import { mockApi, previewFrame } from "@innoclouds/db";
import { isTrustedPreviewOrigin, type PreviewMessage, parsePreviewOrigins } from "@innoclouds/ui";

const TRUSTED_ORIGINS = parsePreviewOrigins(import.meta.env.VITE_PREVIEW_ORIGINS);

const detectParentOrigin = (): string | null => {
	try {
		return window.location.ancestorOrigins?.[0] ?? (document.referrer ? new URL(document.referrer).origin : null);
	} catch {
		return null;
	}
};

export const isPreviewMode = previewFrame !== null;

export const isMockMode = mockApi;

export const previewTile = previewFrame?.tile ?? null;

export const previewParentCandidate = isPreviewMode ? detectParentOrigin() : null;

export const previewParentOrigin = previewParentCandidate && isTrustedPreviewOrigin(previewParentCandidate, TRUSTED_ORIGINS) ? previewParentCandidate : null;

export const postToPreview = (message: PreviewMessage) => {
	if (previewParentOrigin) window.parent.postMessage(message, previewParentOrigin);
};
